import { render, staticRenderFns } from "./LeftLowerBarLiteMaterials.vue?vue&type=template&id=4c4c0e18&scoped=true&"
import script from "./LeftLowerBarLiteMaterials.vue?vue&type=script&lang=js&"
export * from "./LeftLowerBarLiteMaterials.vue?vue&type=script&lang=js&"
import style0 from "./LeftLowerBarLiteMaterials.vue?vue&type=style&index=0&id=4c4c0e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c0e18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4c0e18')) {
      api.createRecord('4c4c0e18', component.options)
    } else {
      api.reload('4c4c0e18', component.options)
    }
    module.hot.accept("./LeftLowerBarLiteMaterials.vue?vue&type=template&id=4c4c0e18&scoped=true&", function () {
      api.rerender('4c4c0e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/LowerBar/LowerBarLeftSide/Lite/LeftLowerBarLiteMaterials.vue"
export default component.exports